













import { defineComponent, computed } from '@vue/composition-api';

import MobileHeader from '@/components/NEW-STRUCTURE/mobile/layout/MobileHeader.vue';
import OutlinedIcon from '../../components/OutlinedIcon.vue';

export default defineComponent({
    emits: [
        'createChannel',
    ],
    components: {
        MobileHeader,
        OutlinedIcon,
    },
});
